import { Component, OnInit } from '@angular/core';
import {QueryProvider} from '@shared/queries/query-provider';
import { SnackBarService } from '@core/services/snack-bar.service';
import { SecurityState } from '@shared/store/reducers/security.reducer';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import {IQueryState} from '@shared/store/reducers/query.reducer';
import {select, Store} from '@ngrx/store';
import {ActivatedRoute, Router} from '@angular/router';
import {BreadcrumbModel} from '@shared/models/breadcrumb.model';
import {Configuration} from '@shared/models/configuration';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import { FileManagerService } from '../../services/file-manager.service';
import {AddFolderDialogComponent} from '../dialog-components/add-folder-dialog/add-folder-dialog.component';
import {map, takeUntil} from 'rxjs/operators';
import {AddFolderModel} from '../../models/file-manager.model';
import {AddFolderAction, DownloadFileAction, UploadFileByParentAction} from '../../store/actions/file-manager.actions';
import { MatDialog } from '@angular/material/dialog';
import {Subject} from 'rxjs';
import {CommandService} from '@core/services/command.service';
import {CreateDirectoryCommand, CreateGlobalDirectoryCommand} from '../../commands/create-directory.command';
import {UploadFileDialogComponent} from '../dialog-components/upload-file-dialog/upload-file-dialog.component';
import {Guid} from 'guid-typescript';
import {FileDialogComponent} from '../file-dialog/file-dialog.component';
import {DriveComponent} from './drive.component';
import {DialogService} from '@shared/services/dialog-service';
import {FileManagementService} from '@core/services/file-management.service';
import {ShareItemService} from '@shared/services/share-item.service';
import {TranslationService} from '../../../translation/services/translation.service';

@Component({
    standalone: false,
    selector: 'particle-orbitax-drive',
  templateUrl: './drive.component.html',
  styleUrls: ['./drive.component.scss']
})
export class OrbitaxDriveComponent extends DriveComponent {
  constructor(store: Store<IQueryState>, activatedRoute: ActivatedRoute,
              dialog: MatDialog, commandService: CommandService, router: Router, dialogService: DialogService,
              fileManagementService: FileManagementService,
              protected snackBarService: SnackBarService,
              protected fileManagerService: FileManagerService,
              protected securityStore: Store<SecurityState>,
              translationService: TranslationService,
              shareItemService: ShareItemService) {
    super(store, activatedRoute, dialog, commandService, router, dialogService, fileManagementService, snackBarService, fileManagerService, securityStore, shareItemService, translationService);
    this.sourceKey = 'VirtualGlobalDirectoryEntry';
    this.breadcrumbKey = 'globalBreadcrumb';
    this.sharedDrivesUrl = 'orbitax-drives';
  }
  navigateByUrl(relativeUrl: string ) {
    this.router.navigateByUrl(`orbitax-drive/${relativeUrl}`);
  }
  createDirectoryCommand(name: string, parentId: string) {
    return new CreateGlobalDirectoryCommand(name, parentId);
  }
  protected isClientFile() {
    return false;
  }
}
